import Toast from '../../components/Toast';
import './pure-video-modal.scss'

interface Props {
  videoModalVisible: boolean
  closeVideoModal: () => void
  videoSrc?: string,
  videoRef?: any
  handleVideoError?: (e: any) => void
}

export const getMineType = (videoSrc: string) => {
  // 根据视频文件扩展名设置正确的MIME类型
  const videoExtension = videoSrc.split('.').pop()?.toLowerCase();
  switch(videoExtension) {
    case 'webm':
      return 'video/webm';
    case 'ogg':
      return 'video/ogg';
      break;
    case 'mov':
      return 'video/quicktime';
    default:
      return 'video/mp4';
  }
}

export default function ({
  videoModalVisible, closeVideoModal, videoSrc,
  videoRef, handleVideoError
}: Props) {
  if (!videoModalVisible) {
    return <></>
  }
  if (!videoSrc) {
    Toast.info('未获取到视频源')
    return <></>
  }
  const videoMimeType = getMineType(videoSrc)
  return <div className="video-modal-overlay" onClick={closeVideoModal}>
    <div className="video-modal-container" onClick={(e) => e.stopPropagation()}>
      <video
        ref={videoRef}
        className="video-modal-video"
        controls
        autoPlay
        onError={handleVideoError}
      >
        <source src={videoSrc} type={videoMimeType} />
        您的浏览器不支持视频播放。
      </video>
      <div className="video-modal-close" onClick={closeVideoModal}></div>
    </div>
  </div>
}

